module.exports = __webpack_public_path__ + "static/media/reportButton.ad713d8a.svg";